// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContributionAccount } from './contribution-account';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionAccountAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  contributionAccountId!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  filename?: string;
  name?: string;
  contributionAccount!: ContributionAccount;
}

